<template>
	<div class="country_selector country_selector_new countrypos LangafterLogin position-relative" >
		<div class="country_selector_btn_wrapper" @click.prevent="lang_hideShow = !lang_hideShow" > 
			<span class="country_selector_flag " :class="flagico"></span>
			<span class="country_selector_name">{{json[langtext]}}</span>
		</div>
		<div class="country_selector_list-wrapper language" v-if="lang_hideShow" @click.prevent="lang_hideShow = lang_hideShow"  >
			<ul class="country_dropdown scrollbar">
				<li @click.prevent="changeLocale('en', 'English', 'flag-eng')"  class="country_dropdown_list_item"> 
					<span class="country_selector_flag flag-eng"></span>
					<span class="country_dropdown_link_name">English</span> 
				</li> 
				<li @click.prevent="changeLocale('es', 'Spanish', 'flag-spa')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-spa"></span>
					<span class="country_dropdown_link_name">Español</span> 
				</li> 
				<li @click.prevent="changeLocale('ar', 'Arabic', 'flag-arb')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-arb"></span>
					<span class="country_dropdown_link_name">عربي</span> 
				</li> 
				<li @click.prevent="changeLocale('zh', 'Chinese', 'flag-chi')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-chi"></span>
					<span class="country_dropdown_link_name">中国人</span> 
				</li>  
				<li @click.prevent="changeLocale('fil', 'Filipino', 'flag-fil')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-fil"></span>
					<span class="country_dropdown_link_name">pilipino</span> 
				</li> 
				<li @click.prevent="changeLocale('ms', 'Malay', 'flag-ms')"  class="country_dropdown_list_item"> 
					<span class="country_selector_flag flag-ms"></span>
					<span class="country_dropdown_link_name">Melayu</span> 
				</li>
				<li @click.prevent="changeLocale('th', 'Thai', 'flag-th')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-th"></span>
					<span class="country_dropdown_link_name">แบบไทย</span> 
				</li>
				<li @click.prevent="changeLocale('vt', 'Vietnamese', 'flag-vt')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-vt"></span>
					<span class="country_dropdown_link_name">Tiếng Việt</span> 
				</li>
				<li @click.prevent="changeLocale('id', 'Indonesian', 'flag-id')"   class="country_dropdown_list_item">
					<span class="country_selector_flag flag-id"></span>
					<span class="country_dropdown_link_name">bahasa Indonesia</span> 
				</li>
			</ul>
		</div> 
	</div>
</template>
<script>
	import $ from 'jquery';
    export default {
        name: 'Login',
        data() {
            return {
                lang_hideShow: false,
				langtext: 'English',
				flagico: 'flag-eng',
				json : {
					'Spanish' :'Español',
					'English' :'English',
					'Chinese' :'中国人',
					'Arabic': 'عربي',
					'Filipino' : 'pilipino',
					'Malay' : 'Melayu',
					'Thai' : 'แบบไทย',
					'Vietnamese' : 'Tiếng Việt',
					'Indonesian' : 'bahasa Indonesia'
				}
            }
        },
		props:['page'],
        methods:{
            changeLocale(locale, lang, flagicon) {
				console.log(locale, lang, flagicon);
                this.langtext= lang;
                this.flagico= "flag "+flagicon;
                this.$i18n.locale = locale;
				this.lang_hideShow = false	
				let input_json={
					'globalParams' :{'lang' : this.langtext},
					'localParams' :{ "parameter" : this  ,'page' : this.page}
				}
				console.log('input_json', input_json, locale, lang, this.langtext);
				localStorage.setItem('lang', this.langtext);
				// 	if (credentials.localParams.page == 'left-bar') {
				// 		//document.cookie = credentials.globalParams.lang;
				// 		COMMON._executeApi(Enpoints.EP_LANGUAGE_API, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
				// 			if (!error) { } else { }
				// 		})
				// 	}
            }
        },
		mounted() {
			const _that = this
			$(document).on('click', function (event) {
				if (!$(event.target).closest('.language').length && !$(event.target).closest('.country_selector_btn_wrapper').length) {
					_that.lang_hideShow = false
				}
			});
		},
		created(){
			if(localStorage.getItem('lang')){
				this.langtext = localStorage.getItem('lang')
				if(localStorage.getItem('lang') == 'Spanish'){
					this.flagico = 'flag-spa'
					this.$i18n.locale = 'es'; 
				}else if(localStorage.getItem('lang') == 'English'){
					this.flagico = 'flag-eng'
					this.$i18n.locale = 'en'; 
				}else if(localStorage.getItem('lang') == 'Arabic'){
					this.flagico = 'flag-arb'
					this.$i18n.locale = 'ar'; 
				}else if(localStorage.getItem('lang') == 'Chinese'){
					this.flagico = 'flag-chi'
					this.$i18n.locale = 'zh'; 
				}else if(localStorage.getItem('lang') == 'Filipino'){
					this.flagico = 'flag-pt'
					this.$i18n.locale = 'pt'; 
				}else if(localStorage.getItem('lang') == 'Malay'){
					this.flagico = 'flag-ger'
					this.$i18n.locale = 'ge'; 
				}else if(localStorage.getItem('lang') == 'Thai'){
					this.flagico = 'flag-french'
					this.$i18n.locale = 'fr'; 
				}else if(localStorage.getItem('lang') == 'Vietnamese'){
					this.flagico = 'flag-greek'
					this.$i18n.locale = 'gr'; 
				}else if(localStorage.getItem('lang') == 'Indonesian'){
					this.flagico = 'flag-greek'
					this.$i18n.locale = 'gr';
				}else{
					this.flagico = 'flag-itly'
					this.$i18n.locale = 'it'; 
				}
			}else{
				this.langtext = 'English'
				this.flagico = 'flag-eng' 
				this.$i18n.locale = 'en'; 
			}
		}
    }
</script>	
		
